import { connect } from 'react-redux';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { errorBoundary, sendTelemetryErrorEvent } from '../../common/react/components/ErrorBoundary';
import { selectShowWelcomeChannelForUserFromAppState } from '../selectors/HomeSelectors';
import { Home, HomeDispatchProps, HomeStateProps } from './Home';


const mapStateToProps: MapStateToProps<HomeStateProps> = (state: AppState) => ({
  userSiteRole: state.session.info.site.role,
  showWelcomeChannel: selectShowWelcomeChannelForUserFromAppState(state),
  favoritesCount: state.home.favorites.items.length,
  recentsCount: state.home.recents.items.length,
  popularCount: state.home.popular.items.length,
  recommendationsCount: state.home.recommendations.items.length,
  isFetchingFavorites: state.home.favorites.isFetching,
  isFetchingRecents: state.home.recents.isFetching,
  isFetchingRecommendations: state.home.recommendations.isFetching,
  recommendationsEnabled: SessionSiteSelectors.isVizRecommendationsEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<HomeDispatchProps> = (dispatch) => ({
  enterHome: () => {
    // Request Channel content
    dispatch(requestSpaceContents());
  }
});

const InternalConnectedHome = connect(mapStateToProps, mapDispatchToProps)(Home);
export const ConnectedHome = errorBoundary(sendTelemetryErrorEvent)(InternalConnectedHome);
